import firedux from '../firedux'
import setCurrentUserPresenceOnFirebase from '../setters/current_user_presence'
import setUserOfflineOnDisconnect from '../setters/set_user_offline_on_disconnect'

import {PRESENCE, CONNECTED_ENDPOINT} from '../../config/constants'

export const watchConnection = (uid) => {

  firedux.ref.child(CONNECTED_ENDPOINT).on('value', (snapshot) => {
    console.log('connection status', snapshot.val() === true ? 'connected' : 'disconnected')

    if (snapshot.val() === true) {
      console.log('should set current user online')
      setCurrentUserPresenceOnFirebase(PRESENCE.ONLINE, uid)
      setUserOfflineOnDisconnect(uid)
    }
    else {
      console.log('should set current user offline')
      setCurrentUserPresenceOnFirebase(PRESENCE.OFFLINE, uid)
    }
  })
}

export const unwatchConnection = () => {
  firedux.ref.child(CONNECTED_ENDPOINT).off()
}



/** WEBPACK FOOTER **
 ** ./modules/shared/data/watchers/connection.js
 **/